// extracted by mini-css-extract-plugin
export default {"ordersList":"_31gbTMWf","orderHeader":"_3khO0JNN","orderContent":"_3VDlZaSO"};